import { useStore } from "../store";

/**
 * True when the signed-in user is a GlobalAdmin.
 *
 * Admin chrome (tenants, jobs, monitoring). Content is gated by
 * useCanUseContent — paid plan, not GlobalAdmin.
 */
export function useIsGlobalAdmin() {
  const profile = useStore((state) => state.profile);
  return profile?.role === "GlobalAdmin";
}
